// extracted by mini-css-extract-plugin
module.exports = {"item":"Contacts_item__3zWoT","label":"Contacts_label__3oldj","value":"Contacts_value__3d6U3"};